import { AfterViewInit, Component, Inject, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { VersioningService } from '@client-monorepo/versioning';
import { FeedbackSheetComponent } from './components/feedback-sheet/feedback-sheet.component';
import { feedBackParamsModel, OpenFeedbackInterface } from './data-access/models/openFeedback.interface';
import { ApiImageService } from '@digipay/ng-ui-api-image';
import { debounceTime } from 'rxjs';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { AbTestService, LayoutService } from '@client-monorepo/common/utilities';
import { Title } from '@angular/platform-browser';
import { NgxEventTrackerService } from '@digipay/ngx-event-tracker';
import { NgxHybridService } from '@digipay/ngx-hybrid-service';
import { IdleTrackerService } from '@client-monorepo/common/user';

declare const window: OpenFeedbackInterface;

@Component({
  standalone: true,
  imports: [RouterModule, CommonModule],
  selector: 'dpx-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  title = 'dpx';
  isResizing = signal(false);
  private versioning = inject(VersioningService);
  bottomSheetService = inject(NgxBottomSheetService);
  apiImageService = inject(ApiImageService);
  router = inject(Router);
  private readonly regex = /[^?]*/;
  private titleService = inject(Title);
  layoutService = inject(LayoutService);
  eventTracker = inject(NgxEventTrackerService);
  private ngxHybridService = inject(NgxHybridService);
  private idleTrackerService = inject(IdleTrackerService);

  constructor(@Inject('APP_ENV') private environment: { [key: string]: string }) {
    this.versioning.run();
    this.eventTracker.init();
    this.apiImageService.prefixUrl = this.environment[AbTestService.callApiWithAbsoluteUrl() ? 'base_url_origin_abs' : 'base_url_origin'];
  }

  ngAfterViewInit() {
    this.subscribeToHorizontalResize();
    setTimeout(() => {
      document.getElementById('nativeSplash')?.remove();
      this.openFeedBackModal();
      this.eventTracker.initIntrackOnSiteMessaging();
      this.eventTracker.initIntrackWebPush();
    }, 3000);
    setTimeout(() => {
      document.getElementById('splash_bg')?.remove();
    }, 500);
    this.titleServiceRouterEvent();
    this.observeAppState();
  }

  private observeAppState(): void {
    if (!this.ngxHybridService.isAndroidHybrid()) return;
    this.idleTrackerService.observeAppStateChange();
  }

  subscribeToHorizontalResize(): void {
    this.layoutService
      .onHorizontalResize()
      .pipe(debounceTime(500))
      .subscribe(() => {
        this.isResizing.set(true);
        setTimeout(() => {
          this.isResizing.set(false);
        }, 10);
      });
  }

  private openFeedBackModal(): void {
    window.openFeedback = (params: feedBackParamsModel) => {
      this.bottomSheetService.openBottomSheet(FeedbackSheetComponent, { feedBackData: params }, { height: '70%' });
    };
  }

  private titleServiceRouterEvent() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.titleService.setTitle('دیجی‌پی | خدمات مالی و پرداخت'); // Reset the title after navigation
      }
    });
  }
}
